import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'xd', 'Xd', [["path",{"d":"M6 8l4 8"}],["path",{"d":"M6 16l4 -8"}],["path",{"d":"M14 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2"}]]);